var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.916 8.727 3.965.282A2.745 2.745 0 0 0 .917.713a2.745 2.745 0 0 0-.745 2.995c.017.043 4.411 8.296 4.411 8.296S.27 20.255.255 20.297a2.744 2.744 0 0 0 .749 2.993 2.756 2.756 0 0 0 1.841.708c.409 0 .819-.092 1.201-.279l17.872-8.438A3.586 3.586 0 0 0 24 12.003c0-1.42-.801-2.675-2.084-3.275ZM2.032 2.967a.745.745 0 0 1 .223-.768.744.744 0 0 1 .838-.116l17.974 8.455c.239.112.438.27.591.462H6.315L2.032 2.967Zm19.034 10.504L3.178 21.917a.738.738 0 0 1-.838-.116.74.74 0 0 1-.223-.769L6.319 13h15.345a1.645 1.645 0 0 1-.597.471Z",
    fill: "#fff",
    opacity: 1,
    "data-original": "#fff",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.5c561ac77c521c095e3ad574aed20dae.svg";
export { ForwardRef as ReactComponent };